import {
  DateStr,
  DateTimeStr,
  ScheduleStatusReport,
  Station,
  toDateRange,
  today,
} from '@mi-front/core';
import { apiClient } from '../../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { ReportType } from '../../../../../../core/reports/types';
import { ScheduleStatusAdsForm } from './form';
import { ScheduleStatusAdsResult } from './ScheduleStatusAdsResult';

interface Props {
  readonly station: Station;
}

export type ScheduleStatusAdsReport = ReportType<
  { from: DateTimeStr; to: DateTimeStr; customId: { customId: string }[] },
  ScheduleStatusReport
>;

export function ScheduleStatusAdsView(p: Props) {
  const tz = useTimezone();

  return (
    <ReportView<ScheduleStatusAdsReport>
      defaultValues={{
        ...toDateRange(today() as DateStr, tz),
        customId: [],
      }}
      runOnLoad
      download={false}
      queryParamsTransform={{
        customId: {
          parse: (input) => input.split(',').map((customId) => ({ customId })),
          serialize: (input: { customId: string }[]) => input.map((v) => v.customId).join(','),
        },
      }}
      reportFn={async (values) => {
        return apiClient.audit.stationReportsScheduleStatusAds(p.station.slug, {
          from: values.from,
          to: values.to,
          customId: (values.customId || []).map(({ customId }) => customId).join(','),
        });
      }}
      Form={ScheduleStatusAdsForm}
      Result={ScheduleStatusAdsResult}
    />
  );
}
